import axios, { AxiosInstance, InternalAxiosRequestConfig, AxiosResponse } from 'axios'

interface ApiClientConfig {
  baseURL?: string
  headers?: Record<string, string>
}

export const createApiClient = ({ baseURL, headers }: ApiClientConfig): AxiosInstance => {
  const apiClient: AxiosInstance = axios.create({
    baseURL,
    headers,
  })

  // Request interceptor
  apiClient.interceptors.request.use(
    async (config: InternalAxiosRequestConfig) => {
      return config
    },
    (error) => {
      return Promise.reject(error)
    },
  )

  // Response interceptor
  apiClient.interceptors.response.use(
    (response: AxiosResponse) => {
      return response
    },
    (error) => {
      // To do: handle response errors
      return Promise.reject(error)
    },
  )

  return apiClient
}
